<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="product-year-tabs">
    <p
      v-if="store.getters['app/hasDualYear']"
      class="selection-hint"
    >
      Selecciona la campaña de códigos
    </p>
    <div class="cards">
      <Card
        v-for="card in yearCards"
        :key="card.year"
        class="year-card"
        tabindex="1"
        :class="[
          'year-card',
          card.class || '',
          {
            active: (selectedYear === card.year && store.getters['app/hasDualYear']),
          }
        ]"
        @click="selectYear(card.year)"
        @keydown.space="selectYear(card.year)"
        @keydown.enter="selectYear(card.year)"
      >
        <template #content>
          <h2 class="title">
            <span
              class="selection-indicator"
              :class="{ selected: selectedYear === card.year }"
              aria-hidden="true"
            />
            Código {{ card.year }}
          </h2>
          <ul>
            <li
              v-for="detailKey in card.details"
              :key="detailKey"
              v-html="homeTexts[card.year]?.[detailKey]"
            />
          </ul>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useStore} from 'vuex';
import Card from 'primevue/card';

const configuredYear = parseInt(STTEDRA_CONFIG_YEAR, 10);
const previousYear = configuredYear - 1;
const currentYear = new Date().getFullYear();
const store = useStore();
const selectedYear = ref(store.state.app.productYear);

const homeTexts = computed(() =>
  store.getters['text/getSectionTexts']('home'),
);

const yearCards = computed(() => {
  if (store.getters['app/hasDualYear']) {
    return [
      {
        year: previousYear,
        details: ['detail-1', 'detail-2', 'detail-3', 'detail-4'],
      },
      {
        year: configuredYear,
        details: ['detail-1', 'detail-2', 'detail-3', 'detail-4'],
      },
    ];
  } else {
    return [
      {
        year: currentYear,
        details: ['detail-1', 'detail-2', 'detail-3', 'detail-4'],
        class: 'single-year',
      },
    ];
  }
});

async function selectYear(year) {
  if (selectedYear.value === year || !store.getters['app/hasDualYear']) return;

  selectedYear.value = year;
  await store.dispatch('app/setProductYear', year);
  await store.dispatch('text/fetchTexts');
}
</script>

<style scoped>
.product-year-tabs {
max-width: 1190px;
margin: 1rem 0;
}
.cards {
  display: flex;
  gap: 1rem;
  justify-content: space-around;
  align-items: stretch;
  padding-bottom: 0.75rem;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
}

.year-card {
  min-width: 320px;
  max-width: 47%;
  cursor: pointer;
  transition: all 0.2s ease;

  border: 1px solid #dcdcdc;
   @media (max-width: 800px) {
    width: 100%;
    max-width: 100%;
  }
}

.year-card:hover {
  background-color: #eeeeee;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.year-card.active {
  background-color: #f0f6ff;
  border: 1px solid var(--primary-color);
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
}

/* Radio base */
.selection-indicator {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #b5b5b5;
  position: relative;
  flex-shrink: 0;
}

/* Seleccionado */
.selection-indicator.selected {
  border-color: var(--primary-color);
}

/* Punto interior */
.selection-indicator.selected::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: var(--primary-color);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.year-card ul {
  padding-left: 1.2rem;
}

.year-card li {
  margin-bottom: 0.4rem;
}
.year-card li::marker {
  color: var(--primary-color);
}

.year-card.single-year {
  max-width: 100%;
  pointer-events: none;
  background: transparent !important;

  width: 100%;
  border: none;
  box-shadow: none;
  @media (max-width: 800px) {
    max-width: 100%;
  }
  &:hover {
    box-shadow: none;
    transform: none;
  }
  .title {
    display: none;
  }
  .p-card-body {
    padding: 0 !important;
    .p-card-content {
      padding: 0 !important;
    }
  }
}

.selection-hint {
  text-align: center;
  font-weight: 500;
  color: #666;
  margin-bottom: 0.75rem;
}
</style>

<style lang="scss">
.year-card a {
  color: inherit;
  text-decoration: none !important;
  font-weight: 600;
}

.year-card a:hover,
.year-card a:focus,
.year-card a:visited,
.year-card a:active {
  color: inherit;
  text-decoration: none;
}
.year-card.single-year{
  .p-card-body {
    padding: 0 !important;
    .p-card-content {
      padding: 0 !important;
    }
  }
}
.year-card{
  .p-card-body {
    .p-card-content {
      padding: 0 !important;
    }
  }
}
</style>
